<template>
  <div class="popups" v-if="modals && modals.length">
    <div class="background" @click.prevent="closeModal(activeModal.name)"></div>

    <Login :bg="bg" v-if="activeModal.name === 'login'" :modal="activeModal" />
    <Register
      :bg="bg"
      v-if="activeModal.name === 'register'"
      :modal="activeModal"
    />
    <Info :bg="bg" v-if="activeModal.name === 'info'" :modal="activeModal" />
    <ChangePassword
      :bg="bg"
      v-if="activeModal.name === 'change-password'"
      :modal="activeModal"
    />
    <AddReview
      :bg="bg"
      v-if="activeModal.name === 'add-review'"
      :modal="activeModal"
    />
    <Restore
      :bg="bg"
      v-if="activeModal.name === 'restore'"
      :modal="activeModal"
    />

    <Output
      :bg="bg"
      v-if="activeModal.name === 'output'"
      :modal="activeModal"
    />
  </div>
</template>

<script>
import Login from "./Login";
import Register from "./Register";
import Info from "./Info";
import ChangePassword from "./ChangePassword";
import AddReview from "./AddReview";
import Restore from "./Restore";
import Output from "./Output";
//
import { mapState, mapActions } from "vuex";
//
export default {
  name: "Modals",
  data() {
    return {
      bg: "#272c35"
    };
  },
  components: {
    Login,
    Register,
    Info,
    ChangePassword,
    AddReview,
    Restore,
    Output
  },
  computed: {
    ...mapState("modals", ["modals"]),

    activeModal() {
      return this.modals && this.modals.length
        ? this.modals[this.modals.length - 1]
        : false;
    }
  },

  methods: {
    ...mapActions("modals", ["closeModal"])
  }
};
</script>

<style>
.popups {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 500;
}

.popups > .background {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 500;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/index.vue